import { IModel, Model, ModelRecord } from '@common/models';
import { StringUtility } from '@common/utils';
import { DateTime } from 'luxon';
export interface IVisitAnesthesiaFormSurgeryVitalModel extends IModel {
  visitAnesthesiaFormSurgeryVitalId: number;
  visitAnesthesiaFormSurgeryId: number;
  fluidRate: string;
  anesthesiaDepth: string;
  iso: string;
  o2Flow: string;
  hr: string;
  sP02: string;
  temperature: string;
  rr: string;
  etcO2: string;
  mm: string;
  systolic: string;
  diastolic: string;
  map: string;
  interval: number;
  dateCreated: string | undefined;
  dateUpdated: string | undefined;
}

export class VisitAnesthesiaFormSurgeryVitalModel
  extends Model
  implements ModelRecord<IVisitAnesthesiaFormSurgeryVitalModel>
{
  visitAnesthesiaFormSurgeryVitalId: number;
  visitAnesthesiaFormSurgeryId: number;
  fluidRate: string;
  anesthesiaDepth: string;
  iso: string;
  o2Flow: string;
  hr: string;
  sP02: string;
  temperature: string;
  rr: string;
  etcO2: string;
  mm: string;
  systolic: string;
  diastolic: string;
  map: string;
  interval: number;
  dateCreated: DateTime | undefined;
  dateUpdated: DateTime | undefined;

  constructor(params?: Partial<IVisitAnesthesiaFormSurgeryVitalModel>) {
    super(params);
    this.visitAnesthesiaFormSurgeryVitalId = _.defaultTo(
      params?.visitAnesthesiaFormSurgeryVitalId,
      0,
    );
    this.visitAnesthesiaFormSurgeryId = _.defaultTo(
      params?.visitAnesthesiaFormSurgeryId,
      0,
    );
    this.fluidRate = _.defaultTo(params?.fluidRate, '');
    this.anesthesiaDepth = _.defaultTo(params?.anesthesiaDepth, '');
    this.iso = _.defaultTo(params?.iso, '');
    this.o2Flow = _.defaultTo(params?.o2Flow, '');
    this.hr = _.defaultTo(params?.hr, '');
    this.sP02 = _.defaultTo(params?.sP02, '');
    this.temperature = _.defaultTo(params?.temperature, '');
    this.rr = _.defaultTo(params?.rr, '');
    this.etcO2 = _.defaultTo(params?.etcO2, '');
    this.mm = _.defaultTo(params?.mm, '');
    this.systolic = _.defaultTo(params?.systolic, '');
    this.diastolic = _.defaultTo(params?.diastolic, '');
    this.map = _.defaultTo(params?.map, '');
    this.interval = _.defaultTo(params?.interval, 0);
    this.dateCreated = StringUtility.SanitizeDateTimeISOAsUtc(
      params?.dateCreated,
    );
    this.dateUpdated = StringUtility.SanitizeDateTimeISOAsUtc(
      params?.dateUpdated,
    );
  }
}
